import AreasImportForm from './AreasImportForm';

export default AreasImportForm;
